import React from 'react';
import { Button } from 'antd';
import './index.less';
import { withRouter } from 'react-router';

const FooterForm = props => {
  const { showBack = true, backUrl = '', height = 60 } = props;

  return (
    <>
      {/* 用于在文档流中预留空间，避免固定底部的表单遮挡内容 */}
      <div style={{ height }} />

      <div className="footer-form" style={{ height }}>
        {showBack && (
          <Button
            onClick={() => {
              if (backUrl === '') {
                window.history.go(-1);
              } else {
                props.history.push(backUrl);
              }
            }}
          >
            返回
          </Button>
        )}

        {props.children}
      </div>
    </>
  );
};

export default withRouter(FooterForm);
